import React, { useState } from "react";
import GuestLayout from "../../../Layout/GuestLayout";
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPassword from './ResetPassword';

const AdminForgotPassword = (props) => {
    const [showComponent, setShowComponent] = useState('ForgotPasswordForm');
    const [formData, setFormData] = useState({email: ''});

    return (
        <>
            <GuestLayout
                Title="Attention is the new currency"
                Subtitle="The more effortless the writing looks, the more effort the
                        writer actually put into the process."
                FormTitle= {showComponent === 'ForgotPasswordForm' ? "Forgot Password" : 'Reset Password'}
                FormSubTitle= {showComponent === 'ForgotPasswordForm' ? "Enter your email to check your account" : 'Enter your password and confirm password'}
            >
                { showComponent === 'ForgotPasswordForm' && 
                    <ForgotPasswordForm 
                        setShowComponent={setShowComponent}
                        setFormData={setFormData}
                    />            
                }
                { showComponent === 'ResetPassword' && 
                    <ResetPassword 
                        formData={formData}
                    />
                }
            </GuestLayout>
        </>
    );
}
export default AdminForgotPassword;
